import { render } from "./resolution-amendment-text-display.vue?vue&type=template&id=1cf62715"
import script from "./resolution-amendment-text-display.vue?vue&type=script&lang=js"
export * from "./resolution-amendment-text-display.vue?vue&type=script&lang=js"

import "./resolution-amendment-text-display.vue?vue&type=style&index=0&id=1cf62715&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__